export const CHECKLIST_WORKSHOP = {
    START_SERVICE_ARG: 1,
    READY_FOR_DELIVERY_ARG: 5,
    START_SERVICE_BRA: 7,
    READY_FOR_DELIVERY_BRA: 11
  };